module.exports = __webpack_public_path__ + "static/media/x.a7410979.png";